import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { SHOW_LOVE_OPTIONS } from '@/pages/Onboarding/options/ShowLove/SHOW_LOVE_OPTIONS';
import { getShowLoveTitleById } from '@/pages/Onboarding/options/ShowLove/utils/getShowLove';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const ShowLoveScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ShowLove',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const showLove = form.watch('show_love');

  const handleSelect = (option: OnbOptionType<LayoutDataType['show_love']>) => {
    form.setValue('show_love', option.id);
  };

  const handleNextStep = () => {
    const showLoveTitle = getShowLoveTitleById(showLove);
    userService.createOrUpdate({
      onboarding_data: {
        show_love: showLoveTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>How Does He Show Love?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid-with-icon">
          {SHOW_LOVE_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={showLove === option.id}
              control={form.control}
              option={option}
              name="show_love"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid-with-icon"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!showLove}
      />
    </OnboardingPage>
  );
};
